import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { lazy, Suspense } from "react";

const Home = lazy(() => import("./pages/Home"));
const Program = lazy(() => import("./pages/Program"));

function App() {
  return (
    <div className="App bg-[#0A0A0A] min-h-screen">
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center font-bebas text-white text-3xl tracking-widest animate-pulse">
              Loading...
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/programs/:slug" element={<Program />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#141414",
            border: "1px solid #27272a",
            color: "#fff",
            borderRadius: 0,
            fontFamily: "DM Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
